import React, { useState } from "react";
import styled from "styled-components";

function NewsletterSubscriptionForm() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState("");

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubscribe = async (event) => {
    event.preventDefault();
    if (!email) {
      setError("Please enter your email address.");
      return;
    }
    try {
      const response = await fetch("https://api.substack.com/api/v1/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          subscribe: true,
          subscribe_all: true,
          substack: "your-substack-username",
        }),
      });
      if (response.ok) {
        setSubscribed(true);
        setError("");
      } else {
        setError("Something went wrong. Please try again later.");
      }
    } catch (error) {
      setError("Something went wrong. Please try again later.");
    }
  };

  return (
    <StyledNewsletterSubscriptionForm>
      {subscribed ? (
        <p>Thank you for subscribing!</p>
      ) : (
        <form onSubmit={handleSubscribe}>
          <label htmlFor="email-input">Subscribe on Substack</label>
          <input
            id="email-input"
            type="email"
            value={email}
            onChange={handleEmailChange}
            placeholder="Email address..."
          />
          <button type="submit">Subscribe</button>
          {error && <p>{error}</p>}
        </form>
      )}
    </StyledNewsletterSubscriptionForm>
  );
}

export default NewsletterSubscriptionForm;

const StyledNewsletterSubscriptionForm = styled.aside`

  input {
    font-size: 1em;
    font-family: var(--font-heading);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.075em;
    padding: 0.5em;
    display: block;
  }

`;
